import axios from "axios";
import ToastManager from "../../../modules/default/popup/alert/apiNotification";
import { GET_USER_INFO_SUCCESS, USER_NOTIFICATION_SETTINGS } from "../../constants/userConstant";

// Update user info data
export const updateUserData = (userdata) => async (dispatch) => {
    const notificationId = ToastManager.showLoading('Updating...');
    try {
        const response = await axios.put('/user/update', userdata);

        if (response.status >= 200 && response.status < 300) {
            ToastManager.showSuccess(notificationId, response.data.message || 'Update successfully!');
            dispatch({ type: GET_USER_INFO_SUCCESS,
				payload: {
					data: response.data.User,
				},
             });
            return true;
        }
    } catch (err) {
        let errorMsg = Object.values(err.response.data).join(', ')
        ToastManager.showError(notificationId, errorMsg || 'Update failed');
    }
};
// Get user notification data
export const getUserNotification = () => async (dispatch) => {
    try {
        const response = await axios.get('/user/settings/notification');

        if (response.status >= 200 && response.status < 300) {
            dispatch({ type: USER_NOTIFICATION_SETTINGS,
				payload: {
					data: response.data,
				},
             });
        }
    } catch (err) {
        let errorMsg = Object.values(err.response.data).join(', ')
        console.log(errorMsg)
    }
};

// Update user notification data
export const updateUserNotification = (notificationSettings) => async (dispatch) => {
    const notificationId = ToastManager.showLoading('Updating...');
    try {
        const response = await axios.put('/user/settings/notification', notificationSettings);

        if (response.status >= 200 && response.status < 300) {
            ToastManager.showSuccess(notificationId, response.data.message || 'Updated successfully!');
            dispatch({ type: USER_NOTIFICATION_SETTINGS,
				payload: {
					data: response.data,
				},
             });
            return true;
        }
    } catch (err) {
        let errorMsg = Object.values(err.response.data).join(', ')
        ToastManager.showError(notificationId, errorMsg || 'Update failed');
    }
};